import { Outlet, Navigate } from "react-router-dom";

import { useCommonStore } from "@stores/index";

export const PrivateRoutes = () => {
  const isAuth = useCommonStore(({ isAuth }) => isAuth);

  return isAuth ? <Outlet /> : <Navigate to="/login" />;
};
